/**
 * @generated SignedSource<<420da8862f222d76314602621c87c8b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsComponent_Store$data = {
  readonly publicTeams: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponentSubItemListItem_Team" | "KPIEditSectionsSectionHeader_Team" | "KPIEditSectionsTeamListItem_Team">;
  }>;
  readonly " $fragmentType": "KPIEditSectionsComponent_Store";
};
export type KPIEditSectionsComponent_Store$key = {
  readonly " $data"?: KPIEditSectionsComponent_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponent_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIEditSectionsComponent_Store",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeArchived",
          "value": true
        }
      ],
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "publicTeams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KPIEditSectionsComponentSubItemListItem_Team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KPIEditSectionsTeamListItem_Team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KPIEditSectionsSectionHeader_Team"
        }
      ],
      "storageKey": "publicTeams(includeArchived:true)"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "4c99a81026647a08a3a02fb806e6e8a3";

export default node;
